export default function termsAndConditionsReducer(state = {
    termsAndConditionsAccepted: null,
    showCloseButton: null,
    latestTermsAndConditions: null,
    acceptTermsAndConditions: {
        fetching: false,
        fetched: false
    }
}, action) {
    switch (action.type) {
        case "TERMS_AND_CONDITIONS": {
            return {
                ...state,
                termsAndConditionsAccepted: action.termsAndConditionsAccepted,
                showCloseButton: action.showCloseButton
            }
        }
        case "GET_LATEST_TERMS_AND_CONDITIONS_FULFILLED": {
            return {
                ...state,
                latestTermsAndConditions: action.payload.data.payload
            }
        }
        case "ACCEPT_TERMS_AND_CONDITIONS_PENDING": {
            return {
                ...state,
                acceptTermsAndConditions: {
                    fetching: true,
                    fetched: false
                }
            }
        }
        case "ACCEPT_TERMS_AND_CONDITIONS_REJECTED": {
            return {
                ...state,
                acceptTermsAndConditions: {
                    fetching: false,
                    fetched: false
                }
            }
        }
        case "ACCEPT_TERMS_AND_CONDITIONS_FULFILLED": {
            return {
                ...state,
                acceptTermsAndConditions: {
                    fetching: false,
                    fetched: true
                }
            }
        }
        default : {
            return state
        }
    }
}